import { ChangeDetectionStrategy, Component, computed, Inject, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { User } from 'src/app/models/user.model';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { AnswersStore } from 'src/app/store/answers-store';
import { GlobalStore } from 'src/app/store/global-store';
import { environment } from 'src/environment';
import { EApprovalStatus } from 'src/app/models/approval.model';
import { LogoDisplayComponent } from "src/app/features/create-questionnaire-page/component/question-board/logo-display/logo-display.component";

export enum EnumApproverType {
  FirstManager = 1,
  SecondManager = 2
}

@Component({
    selector: 'que-popup-expense-approval',
    imports: [CommonModule, TranslateDirective, TranslatePipe, OverlayModule, ReactiveFormsModule, LogoDisplayComponent],
    templateUrl: './popup-expense-approval.component.html',
    styleUrls: ['./popup-expense-approval.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopupExpenseApprovalComponent implements OnInit {
  private dialogRef = inject(MatDialogRef<PopupExpenseApprovalComponent>);
  #questionnaireStore = inject(QuestionnaireStore);
  #answersStore = inject(AnswersStore);
  #globalStore = inject(GlobalStore);

  questionarrieSig$ = toSignal(this.#questionnaireStore.questionnaire$);
  loggedUserDetails$ = toSignal(this.#globalStore.loggedUserDetails$);
  language = environment.lang;
  amount$ = toSignal(this.#answersStore.amount$);
  commentControl = new FormControl<string>("");
  selectedResponseName?: string;

  enum = EApprovalStatus;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { type: EApprovalStatus, name:string }) {


  }
  ngOnInit(): void {
  }

  close(): void {
    this.dialogRef.close();
  }

  confirm(): void {

    this.dialogRef.close({
      status: this.data.type,
      comment: this.commentControl.value ?? null

    });
  }
  get isSubmitDisabled(): boolean {

    if (this.data.type === EApprovalStatus.Rejected) {
      return !this.commentControl.value?.trim();
    }

    return false;
  }
}
